/**
 * The responsbility of the constant.js file is to store all the constant variables that are used in the application.
 * This is done to ensure that the code is more maintainable and readable.
 * This variables value can be changed from this file and it will reflect in the entire application.
 * Through the admin setting admin can change the value of the variables using api and it will reflect in the application.
 */

// Booking Constant
export const BOOKING = {
    maxTicketQtyLimitPerBooking: 10
};

export const companyName = 'Shmooz socials LLP';

export const companyEmail = 'info@shmooz.in';

export const companyPhone = '+91 98985 82640';

export const companyAddress = '401/501 Riviera Towers, Behind Goverdhan Haveli, Opp. Rahul Raj Mall, Piplod, Surat – 395007, India';

export const companyGSTIN = '24AATFT7815P1Z8';

export const lastUpdatedPolicyDate = '23 September 2025';

export const EVENT_STATUS = {
    scheduled: 'scheduled',
    live: 'ongoing',
    ended: 'event_ended',
    cancelled: 'cancelled',
    drafted: 'drafted'
};

export const EVENT_TYPES = {
    singleDay: 'single_day',
    multiDay: 'multi_day',
    continuous: 'continuous'
};

// Ticket Status Constant
export const TICKET_STATUS = {
    scheduled: 'scheduled',
    live: 'live',
    soldOut: 'sold_out',
    saleEnded: 'sale_ended',
    commingSoon: 'coming_soon'
};

// Success, Error, Warning, Info etc.. color
export const COLOR = {
    success: '#06CD47',
    failed: '#EA0104',
    default: '#f8a21e'
};

export const invitationResponseStatus = {
    confirmed: 'yes',
    rejected: 'no',
    pending: 'pending'
};

export const RUPEE_SYMBOL = '₹';

export const MAX_VENUE_BOOKING_REQUEST = 3;

export const PLATFORM_NOT_DECIDED = 'Platform not decided';

// Coverage constant in map and location search
export const MAP_RESTRICTION = {
    cityRestriction: {
        surat: {
            north: 21.282187,
            south: 21.044725,
            east: 72.965324,
            west: 72.596173
        }
    },
    countries: {
        country: ['in']
    }
};

// surat center area lat and lng to show in map
export const SURAT_CENTER = {
    lat: 21.1702,
    lng: 72.8311
};

// Max Invitee limit
export const MAX_INVITEE_LIMIT = 30;

// Auto cancel event if location not provided within given hours (2 days = 48 hours)
/**
 * backend send 1 email as reminder between 48 hours to 36 hours before auto cancellation
 * then reminder 2 will be sent between 36 hours to 24 hours before auto cancellation
 * then event will be auto drafted if time is < 24 hours. if location is not provided
 */
export const AUTO_CANCEL_EVENT_HOURS = 48;